import { h } from 'vue';

// Duotone nav icons ported from the CrmB mockup. Their colours are a fixed
// brand palette for categories, deliberately NOT tied to the theme tokens —
// the mockup keeps them identical on light and dark surfaces.
const svg = (children, viewBox = '0 0 18 18') =>
  h(
    'svg',
    {
      width: 17,
      height: 17,
      viewBox,
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      class: 'flex-shrink-0',
    },
    children
  );

export const inboxIcon = () =>
  svg([
    h('rect', {
      x: 1.5,
      y: 2.6,
      width: 15,
      height: 12.8,
      rx: 3.6,
      fill: '#f06a6a',
      opacity: 0.32,
    }),
    h('path', {
      d: 'M2.4 6.6 9 10.9l6.6-4.3',
      fill: 'none',
      stroke: '#f06a6a',
      'stroke-width': 1.8,
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
    }),
  ]);

export const activityIcon = () =>
  svg([
    h('path', {
      d: 'M9 2.5a4.5 4.5 0 0 0-4.5 4.5v2.8L3 12.3h12l-1.5-2.5V7A4.5 4.5 0 0 0 9 2.5z',
      fill: '#6b8fb5',
      opacity: 0.38,
    }),
    h('path', {
      d: 'M7 14.2a2 2 0 0 0 4 0',
      fill: 'none',
      stroke: '#5a7ea6',
      'stroke-width': 1.8,
      'stroke-linecap': 'round',
    }),
  ]);

export const contactsIcon = () =>
  svg([
    h('circle', { cx: 13.3, cy: 6.6, r: 2.3, fill: '#4573d2', opacity: 0.42 }),
    h('path', {
      d: 'M11.9 10.9c2.7-.2 4.6 1.5 4.7 4.5h-3.2z',
      fill: '#4573d2',
      opacity: 0.42,
    }),
    h('circle', { cx: 7, cy: 6, r: 3.1, fill: '#4573d2' }),
    h('path', {
      d: 'M1.6 15.4c.5-3 2.7-4.6 5.4-4.6s4.9 1.6 5.4 4.6z',
      fill: '#4573d2',
    }),
  ]);

export const companiesIcon = () =>
  svg([
    h('rect', {
      x: 3,
      y: 2.5,
      width: 12,
      height: 13,
      rx: 2,
      fill: '#7e8aa0',
      opacity: 0.35,
    }),
    h('rect', {
      x: 6,
      y: 5.5,
      width: 2.2,
      height: 2.2,
      rx: 0.5,
      fill: '#5f6d85',
    }),
    h('rect', {
      x: 9.8,
      y: 5.5,
      width: 2.2,
      height: 2.2,
      rx: 0.5,
      fill: '#5f6d85',
    }),
    h('rect', {
      x: 6,
      y: 9.5,
      width: 2.2,
      height: 2.2,
      rx: 0.5,
      fill: '#5f6d85',
    }),
    h('rect', {
      x: 9.8,
      y: 9.5,
      width: 2.2,
      height: 2.2,
      rx: 0.5,
      fill: '#5f6d85',
    }),
  ]);

export const tasksIcon = () =>
  svg([
    h('rect', {
      x: 1.6,
      y: 1.6,
      width: 14.8,
      height: 14.8,
      rx: 4.4,
      fill: '#3ec46d',
      opacity: 0.3,
    }),
    h('path', {
      d: 'M5.2 9.1 7.6 11.5l5.2-5.2',
      fill: 'none',
      stroke: '#2fa557',
      'stroke-width': 2,
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
    }),
  ]);

export const captainIcon = () =>
  svg([
    h('path', {
      d: 'M9 2l1.6 4.4L15 8l-4.4 1.6L9 14l-1.6-4.4L3 8l4.4-1.6z',
      fill: '#e0559b',
      opacity: 0.38,
    }),
    h('circle', { cx: 14, cy: 13.5, r: 1.7, fill: '#e0559b' }),
  ]);

export const reportsIcon = () =>
  svg([
    h('rect', {
      x: 1.8,
      y: 9,
      width: 3.6,
      height: 7.2,
      rx: 1.6,
      fill: '#a55ee0',
      opacity: 0.42,
    }),
    h('rect', {
      x: 7.2,
      y: 4.4,
      width: 3.6,
      height: 11.8,
      rx: 1.6,
      fill: '#a55ee0',
    }),
    h('rect', {
      x: 12.6,
      y: 7,
      width: 3.6,
      height: 9.2,
      rx: 1.6,
      fill: '#a55ee0',
      opacity: 0.42,
    }),
  ]);

export const attributionIcon = () =>
  svg([
    h('path', {
      d: 'M9 1.8 2.4 5.4v7.2L9 16.2l6.6-3.6V5.4z',
      fill: '#f5a623',
      opacity: 0.34,
    }),
    h('path', { d: 'M9 5.6 5.6 7.4v3.2L9 12.4l3.4-1.8V7.4z', fill: '#e0900d' }),
  ]);

export const campaignsIcon = () =>
  svg([
    h('path', {
      d: 'M2.2 7.1 11 3.2v11.6L2.2 10.9z',
      fill: '#e8709a',
      opacity: 0.38,
    }),
    h('path', {
      d: 'M4.6 11.4v3.1a1.7 1.7 0 0 0 3.4 0v-1.6z',
      fill: '#d4457a',
    }),
    h('path', {
      d: 'M13.6 6.4a3.6 3.6 0 0 1 0 5.2',
      fill: 'none',
      stroke: '#d4457a',
      'stroke-width': 1.8,
      'stroke-linecap': 'round',
    }),
  ]);

export const helpCenterIcon = () =>
  svg([
    h('path', {
      d: 'M3 4a1.5 1.5 0 0 1 1.5-1.5H9v13H4.5A1.5 1.5 0 0 1 3 14z',
      fill: '#2fb5a4',
      opacity: 0.38,
    }),
    h('path', {
      d: 'M15 4a1.5 1.5 0 0 0-1.5-1.5H9v13h4.5A1.5 1.5 0 0 0 15 14z',
      fill: '#2fb5a4',
    }),
  ]);

export const settingsIcon = () =>
  svg([
    h('path', {
      d: 'M3.2 5.6h11.6M3.2 12.4h11.6',
      fill: 'none',
      stroke: '#14aaf5',
      'stroke-width': 1.8,
      'stroke-linecap': 'round',
      opacity: 0.5,
    }),
    h('circle', { cx: 6.9, cy: 5.6, r: 2.6, fill: '#14aaf5' }),
    h('circle', { cx: 11.4, cy: 12.4, r: 2.6, fill: '#0f8ecd' }),
  ]);

// Small coloured dot used by the "Saved views" rows. Wrapped in a 16px box so
// it sits centred where an icon would.
//
// Every export here is a factory returning a fresh VNode — call it at the use
// site (`icon: inboxIcon()`) rather than passing the function itself: Icon.vue
// hands whatever it gets to `<component :is>`, and a bare function there
// ends up normalised to a text node.
export const viewDot = color =>
  h(
    'span',
    { class: 'flex items-center justify-center size-4 flex-shrink-0' },
    [
      h('span', {
        class: 'size-1.5 rounded-full',
        style: { backgroundColor: color },
      }),
    ]
  );

// Same tonal set the mockup uses for its saved-view dots.
export const VIEW_DOT_PALETTE = ['#d9a63a', '#7aa8d8', '#7fd0dd', '#c05a45'];
